import * as tslib_1 from "tslib";
import { TextField } from './text_field';
var MultiTextBox = /** @class */ (function (_super) {
    tslib_1.__extends(MultiTextBox, _super);
    function MultiTextBox(param) {
        return _super.call(this, param) || this;
    }
    MultiTextBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "MultiTextBox" });
    };
    MultiTextBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return MultiTextBox;
}(TextField));
export { MultiTextBox };
//# sourceMappingURL=multi_text_box.js.map